import { ModerationView } from './ModerationView';

interface Props {
  standalone: boolean;
}

export function App({ standalone }: Props): JSX.Element {
  return <ModerationView standalone={standalone} />;
}
